export interface MapItemProps {
	title: string;
	description: string;
	imgSrcClass: string;
	href: string;
}

export const MapItemComponent = (props: MapItemProps) => {
	return (
		<a className={props.imgSrcClass} href={props.href}>
			<div className="gradient-wrapper"></div>
			<p className="text">
				<span className="title">{props.title}</span>
				<span className="description">{props.description}</span>
			</p>
		</a>
	);
}